import type { ComposeMessageModalData } from "@/lib/modals/modal-data/communications";
import type { SendTextMessageModalData } from "@/lib/modals/data/legacy-modal-data";

export interface ContactMethodEntityContext {
  item?: Record<string, unknown>;
  entityType?: string;
}

function readString(record: Record<string, unknown> | undefined, key: string): string | undefined {
  const value = record?.[key];
  return typeof value === "string" && value.trim().length > 0 ? value.trim() : undefined;
}

export function buildComposeModalDataFromContext(
  email: string,
  context?: ContactMethodEntityContext
): ComposeMessageModalData {
  const item = context?.item;
  const trimmedEmail = email.trim();
  const customerName =
    readString(item, "name") ??
    readString(item, "contact_name") ??
    readString(item, "company_name");
  const companyId = readString(item, "company_id");
  const contactId =
    context?.entityType === "contacts" || context?.entityType === "contact"
      ? readString(item, "id")
      : readString(item, "contact_id");

  const initialRecipients: ComposeMessageModalData["initialRecipients"] = [
    {
      type: "email",
      email: trimmedEmail,
      name: customerName,
      id: contactId ?? trimmedEmail,
    },
  ];

  return {
    mode: "compose",
    customerEmail: trimmedEmail,
    customerName,
    companyId,
    contactId,
    item,
    initialRecipients,
  };
}

export function buildSendTextModalDataFromContext(
  phone: string,
  context?: ContactMethodEntityContext
): SendTextMessageModalData {
  const item = context?.item;
  const trimmedPhone = phone.trim();
  const recipientName =
    readString(item, "name") ??
    readString(item, "contact_name") ??
    readString(item, "company_name");

  return {
    item,
    entityType: context?.entityType,
    recipientPhone: trimmedPhone,
    recipientName,
    initialContactId:
      context?.entityType === "contacts" || context?.entityType === "contact"
        ? readString(item, "id")
        : readString(item, "contact_id"),
  };
}
